import {
  IInteractiveTemplateField,
  InteractiveTemplateFieldType,
} from '../../models/InteractiveTemplate'
import * as Yup from 'yup'
import { SelectItem } from '../../models/SelectIem'
import { FormRegex } from '../../models/Common'

export const buildSelectItems = (values: string[]) => {
  if (values) {
    return values.map((value) => {
      const item: SelectItem = {
        text: value,
        key: value,
        value: value,
        checked: false,
        parentkey: '',
      }
      return item
    })
  }
}

export const getFieldSchema = (schema, field) => {
  if (field.type === InteractiveTemplateFieldType.Address) {
    return getAddressSchema(schema, field)
  }
  if (
    field.type === InteractiveTemplateFieldType.Hidden ||
    field.type === InteractiveTemplateFieldType.Instruction
  ) {
    // skip validation for hidden field
    return schema
  }
  if (field.type === InteractiveTemplateFieldType.Phone) {
    return field.required
      ? {
          ...schema,
          [field.replacement]: Yup.string()
            .required('This field cannot be empty, it is required.')
            .typeError('This field cannot be empty, it is required.')
            .matches(FormRegex.Phone, 'Please enter a valid phone number')
            .min(6, 'Requires a minimum of 6 characters')
            .max(20, 'Must be exactly 20 or less characters')
            .nullable(true),
        }
      : {
          ...schema,
          [field.replacement]: Yup.string()
            .optional()
            .matches(FormRegex.Phone, 'Please enter a valid phone number')
            .min(6, 'Requires a minimum of 6 characters')
            .max(20, 'Must be exactly 20 or less characters')
            .nullable(true),
        }
  }
  if (field.type === InteractiveTemplateFieldType.Email) {
    return field.required
      ? {
          ...schema,
          [field.replacement]: Yup.string()
            .required('This field cannot be empty, it is required.')
            .matches(FormRegex.Email, 'Please enter a valid email address')
            .max(100, 'Must be exactly 100 or less characters'),
        }
      : {
          ...schema,
          [field.replacement]: Yup.string()
            .optional()
            .matches(FormRegex.Email, 'Please enter a valid email address')
            .max(100, 'Must be exactly 100 or less characters'),
        }
  }
  if (field.type === InteractiveTemplateFieldType.Date) {
    return field.required
      ? {
          ...schema,
          [field.replacement]: Yup.string()
            .required('This field cannot be empty, it is required.')
            .matches(
              FormRegex.Date,
              'Please enter a valid date in DD/MM/YYYY format'
            ),
        }
      : {
          ...schema,
          [field.replacement]: Yup.string()
            .optional()
            .matches(
              FormRegex.Date,
              'Please enter a valid date in DD/MM/YYYY format'
            ),
        }
  }
  return field.required
    ? {
        ...schema,
        [field.replacement]: Yup.string().required(
          'This field cannot be empty, it is required.'
        ),
      }
    : schema
}

export const buildAddressFromValues = (key, values) => {
  const street = values[`${key}_STREET`]
  const suburb = values[`${key}_SUBURB`]
  const state = values[`${key}_STATE`]
  const postcode = values[`${key}_POSTCODE`]

  if (
    street?.length > 0 &&
    suburb?.length > 0 &&
    state?.length > 0 &&
    postcode?.length > 0
  ) {
    return `${street}, ${suburb}, ${state} ${postcode}`
  } else {
    return ''
  }
}

export const getAddressSchema = (schema, field) => {
  return field.required
    ? {
        ...schema,
        [`${field.replacement}_STREET`]: Yup.string().required(
          `${field.label} is required`
        ),
        [`${field.replacement}_SUBURB`]: Yup.string().required(
          `${field.label} is required`
        ),
        [`${field.replacement}_POSTCODE`]: Yup.string().required(
          `${field.label} is required`
        ),
        [`${field.replacement}_STATE`]: Yup.string().required(
          `${field.label} is required`
        ),
      }
    : schema
}

export const getInitialValues = (template) => {
  const initialValues = {}
  if (template?.pages) {
    template.pages.map((page) => {
      if (page?.sections) {
        page.sections.map((section) => {
          if (section?.fields) {
            section.fields.map((field) => {
              if (field.type === InteractiveTemplateFieldType.Checkbox) {
                field.values?.map((_, index) => {
                  initialValues[`${field.replacement}_${index}`] = ''
                })
              } else if (field.type === InteractiveTemplateFieldType.Address) {
                // split address into Street, City, Postcode & State
                initialValues[`${field.replacement}_STREET`] = ''
                initialValues[`${field.replacement}_SUBURB`] = ''
                initialValues[`${field.replacement}_POSTCODE`] = ''
                initialValues[`${field.replacement}_STATE`] = ''
              } else if (field.type === InteractiveTemplateFieldType.Hidden) {
                initialValues[`${field.replacement}`] =
                  field.values && field.values.length > 0 ? field.values[0] : ''
              } else {
                initialValues[field.replacement] = ''
              }
            })
          }
        })
      }
    })
  }
  return initialValues
}

export const getPageFields = (page) => {
  const fields: IInteractiveTemplateField[] = []
  page?.sections?.map((section) => {
    if (section?.fields) {
      section.fields.map((field) => {
        fields.push(field)
      })
    }
  })
  return fields
}

export const getFields = (template) => {
  const fields: IInteractiveTemplateField[] = []
  if (template?.pages) {
    template.pages.map((page) => {
      if (page?.sections) {
        page.sections.map((section) => {
          if (section?.fields) {
            section.fields.map((field) => {
              fields.push(field)
            })
          }
        })
      }
    })
  }
  return fields
}
